import "./Breadcrumb.css";

function Breadcrumb({ icon, items = [], current }) {
  return (
    <div className="breadcrumb">
      <nav>
        {/* Icon and first separator */}
        {icon && (
          <>
            <img src={icon} alt="breadcrumb icon" className="breadcrumb-icon" />
            <span className="breadcrumb-separator"> &gt; </span>
          </>
        )}

        {/* Items with separators after each except the last */}
        {items.map((item, idx) => (
          <span key={idx} className="breadcrumb-item">
            {item}
            <span className="breadcrumb-separator"> &gt; </span>
          </span>
        ))}

        {/* Current item */}
        <span className="breadcrumb-current">{current}</span>
      </nav>
    </div>
  );
}

export default Breadcrumb;